import { v5 as uuidv5 } from 'uuid';

const broadcastChannelPolyfillKey = uuidv5(
  'https://certi.programmers.co.kr/boradcast-channel-polyfill',
  uuidv5.URL,
);

(function (global) {
  if (!global.localStorage || !global.MessageChannel) return;
  const channels: Record<string, BroadcastChannel[]> = {};

  class BroadcastChannel {
    private readonly _name: string;
    private readonly _id: string;
    private _closed: boolean;
    private readonly _mc: MessageChannel;
    private readonly _storageListener: (e: StorageEvent) => void;

    constructor(channel: string) {
      const $this = this;
      const id = `$${broadcastChannelPolyfillKey}$${channel}$`;

      channels[id] ??= [];
      channels[id].push(this);

      this._name = channel;
      this._id = id;
      this._closed = false;
      this._mc = new MessageChannel();
      this._mc.port1.start();
      this._mc.port2.start();
      this._storageListener = (e) => {
        if (e.storageArea !== global.localStorage) return;
        if (e.newValue === null) return;
        if (!e.key?.startsWith(id)) return;
        const data = JSON.parse(e.newValue);
        $this._mc.port2.postMessage(data);
      };

      global.addEventListener('storage', this._storageListener);
    }

    get name() {
      return this._name;
    }

    postMessage(message: any) {
      const $this = this;
      if (this._closed) {
        const e = new Error();
        e.name = 'InvalidStateError';
        throw e;
      }
      const value = JSON.stringify(message);

      const key = this._id + String(Date.now()) + '$' + String(Math.random());
      global.localStorage.setItem(key, value);
      setTimeout(() => {
        global.localStorage && global.localStorage.removeItem(key);
      }, 0);

      channels[this._id].forEach((bc) => {
        if (bc === $this) return;
        bc._mc.port2.postMessage(JSON.parse(value));
      });
    }

    close() {
      if (this._closed) return;
      this._closed = true;
      this._mc.port1.close();
      this._mc.port2.close();

      const index = channels[this._id].indexOf(this);
      channels[this._id].splice(index, 1);
      global.removeEventListener('storage', this._storageListener);
    }

    get onmessage() {
      return this._mc.port1.onmessage;
    }

    set onmessage(value) {
      this._mc.port1.onmessage = value;
    }

    get onmessageerror() {
      return this._mc.port1.onmessageerror;
    }

    set onmessageerror(value) {
      this._mc.port1.onmessageerror = value;
    }

    addEventListener(type: 'message' | 'messageerror', listener: EventListenerOrEventListenerObject) {
      return this._mc.port1.addEventListener.apply(this._mc.port1, [type, listener]);
    }

    removeEventListener(type: 'message' | 'messageerror', listener: EventListenerOrEventListenerObject) {
      return this._mc.port1.removeEventListener.apply(this._mc.port1, [type, listener]);
    }

    dispatchEvent(event: Event) {
      return this._mc.port1.dispatchEvent.apply(this._mc.port1, [event]);
    }
  }

  Object.assign(global, { BroadcastChannel });
}(globalThis));
